import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Table, Form } from "react-bootstrap";

import "./empty_containers.styles.scss";
import classes from "../Inventory/inventory.module.scss";

import Head from "@/components/Content/Head";
import Th from "@/components/Table/Th";
import Fetching from "@/components/Fetching/Fetching";
import EmptyContainerTable from "./EmptyContainerTable";

import { hasPermission } from "@/services/Utils";
import api from "@/services/api.service";

import { base_filters, head_table } from "./emptyContainer.constants";
import BasePagination from "@/components/Pagination/BasePagination";
import EmptyContainerFilter from "./EmptyContainerFilter";
import ButtonFilter from "@/components/Filter/ButtonFilter";
import EmptyContainerFunctions from "./EmptyContainerFunctions";
import EmptyContainerFunctionsSelect from "./EmptyContainerFunctionsSelect";
import BasicConfirm from "@/components/Confirm/BasicConfirm";

const EmptyContainer = () => {
	const { estate_id, search } = useSelector((state) => state.auth.filter);

	const [paginate, setPaginate] = useState(10);
	const [emptyContainers, setEmptyContainers] = useState([]);
	const [permissions, setPermissions] = useState([]);
	const [quantity, setQuantityElements] = useState(0);
	const [from, setFromElements] = useState(0);
	const [to, setToElements] = useState(0);
	const [last_page, setLastPage] = useState(1);

	const [page, setPage] = useState(1);
	const [order, setOrder] = useState("tradename");
	const [orderType, setOrderType] = useState("asc");
	const [isFetching, setIsFetching] = useState(true);
	const [total, setTotal] = useState(0);

	const [showConfirm, setShowConfirm] = useState(false);
	const [selected, setSelected] = useState([]);
	const [titles, setTitles] = useState([]);
	const [showFilter, setShowFilter] = useState(false);
	const [filters, setFilters] = useState({ ...base_filters });

	useEffect(() => {
		setIsFetching(true);
		api.get("/client/empty_containers", {
			...filters,
			page,
			paginate,
			search,
			order,
			orderType,
			estate_id,
		}).then((response) => {
			updateData(response);
			setIsFetching(false);
		});
	}, [page, paginate, search, order, orderType, estate_id, filters]);

	const updateData = (response) => {
		const { empty_containers, permissions, total, titles } = response;

		setEmptyContainers(empty_containers.data);
		setQuantityElements(empty_containers.total);
		setFromElements(empty_containers.from);
		setToElements(empty_containers.to);
		setLastPage(empty_containers.last_page);
		setTotal(total);
		setPermissions(permissions);
		setTitles(titles);
		setIsFetching(false);
	};

	const applyFilter = (params) => {
		let new_filters = { ...filters };

		if (params.defaultUnitFilter !== filters.unit_measurement) {
			new_filters = {
				...new_filters,
				unit_measurement: params.defaultUnitFilter,
			};
		}
		if (params.dateFilter !== filters.date) {
			new_filters = {
				...new_filters,
				date: params.dateFilter,
			};
		}
		if (params.dateToFilter !== filters.dateTo) {
			new_filters = {
				...new_filters,
				dateTo: params.dateToFilter,
			};
		}
		if (params.showAllFilter !== filters.show_all) {
			new_filters = {
				...new_filters,
				show_all: params.showAllFilter,
			};
		}

		setFilters(new_filters);
		setShowFilter(false);
	};

	const handelCheckAll = (e) => {
		let newSelected = [...selected];

		if (e.target.checked) {
			emptyContainers.forEach((product) => {
				product.details.forEach((inventory) => {
					if (e.target.checked && !newSelected.includes(inventory.original_id)) {
						newSelected.push(inventory.original_id);
					}
				});
			});
			setSelected(newSelected);
		} else {
			setSelected([]);
		}
	};

	const handleCheckProduct = (product, e) => {
		let newSelected = [...selected];

		product.details.forEach((element) => {
			if (e.target.checked) {
				if (!newSelected.includes(element.original_id)) {
					newSelected.push(element.original_id);
				}
			} else {
				newSelected = newSelected.filter((ns) => Number(ns) !== Number(element.original_id));
			}
		});

		setSelected(newSelected);
	};

	const handleCheckInventory = (inventory, e) => {
		let newSelected = [...selected];

		if (e.target.checked) {
			if (!newSelected.includes(inventory.original_id)) {
				newSelected.push(inventory.original_id);
			}
		} else {
			newSelected = newSelected.filter((ns) => Number(ns) !== Number(inventory.original_id));
		}

		setSelected(newSelected);
	};

	const handleGlobalDelete = () => {
		setIsFetching(true);
		api.post("/client/empty_containers/delete", {
			...filters,
			page,
			paginate,
			search,
			order,
			orderType,
			estate_id,
			selected,
		}).then((response) => {
			setSelected([]);
			setShowConfirm(false);
			updateData(response);
			setIsFetching(false);
		});
	};

	if (isFetching) {
		return <Fetching />;
	}

	return (
		<>
			<Head title={"Envases vacíos"} titles={titles} />

			<ButtonFilter origin="main" size_md={12} showFilter={showFilter} setShowFilter={setShowFilter} show_back={true} />

			<Row className={`no_print ${classes.inventoryGlobal}`}>
				{showFilter && (
					<EmptyContainerFilter
						defaultUnit={filters.unit_measurement}
						date={filters.date}
						dateTo={filters.dateTo}
						showAll={filters.show_all}
						applyFilter={applyFilter}
					/>
				)}

				<Col md={showFilter ? 9 : 12} className={classes.inventory}>
					<EmptyContainerFunctions showFilter={showFilter} setShowFilter={setShowFilter} permissions={permissions} total={total} />

					{selected.length > 0 && <EmptyContainerFunctionsSelect permissions={permissions} setShowConfirm={setShowConfirm} />}

					<Row className={`${classes.table} ${selected.length > 0 && classes.table_min}`}>
						{hasPermission("show", permissions) && (
							<>
								<Table className={classes.table_desktop}>
									<thead>
										<tr>
											<th
												style={{
													borderTop: "0px",
													borderBottom: "0.5px solid #dee2e6",
												}}
											>
												<Form.Check
													style={{
														marginLeft: "18px",
													}}
													type="checkbox"
													onChange={(e) => handelCheckAll(e)}
												/>
											</th>
											{head_table.map((item, i) => {
												return (
													<Th
														key={i}
														item_name={item.name}
														item_size={item.size}
														item_order={item.order}
														order={order}
														setOrder={setOrder}
														orderType={orderType}
														setOrderType={setOrderType}
														item_class={item.class}
														item_check_permission={item.check_permission}
													/>
												);
											})}
										</tr>
									</thead>

									<EmptyContainerTable
										selected={selected}
										handleCheckProduct={handleCheckProduct}
										handleCheckInventory={handleCheckInventory}
										emptyContainers={emptyContainers}
										setEmptyContainers={setEmptyContainers}
									/>
								</Table>
							</>
						)}
					</Row>

					<BasePagination
						page={page}
						paginate={paginate}
						last_page={last_page}
						quantity={quantity}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<BasicConfirm
				showConfirm={showConfirm}
				setShowConfirm={setShowConfirm}
				handleAction={handleGlobalDelete}
				message={"Seguro desea eliminar los envases seleccionados?"}
				showValidation={true}
				textValidation={"eliminar envases"}
			/>
		</>
	);
};

export default EmptyContainer;
